import { render } from "./BaseModel.vue?vue&type=template&id=c67e2a2e&scoped=true"
import script from "./BaseModel.vue?vue&type=script&lang=js"
export * from "./BaseModel.vue?vue&type=script&lang=js"

import "./BaseModel.vue?vue&type=style&index=0&id=c67e2a2e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c67e2a2e"

export default script